import { PSCType } from "@/graphql";
import type { ActionButtonType } from "./ActionButton";
import PSCCreate from "@/modules/psc/views/PSCCreate.vue";

const CreateA5Button: ActionButtonType = {
  label: "components.eventAction.event.actionButtons.CreateA5Button.text",
  disabled: false,
  modalComponent: PSCCreate,
  modalComponentAdditionalBind: {
    showInModal: true,
    type: PSCType.A5,
  },
};

export default CreateA5Button;
